import { Link } from "react-router-dom";
import { Store, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 text-center">
      <Seo
        title="Page Not Found"
        path="/404"
        description="The page you are looking for could not be found at Nyali Plaza."
      />
      <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center mb-6">
        <Store className="w-8 h-8 text-white" />
      </div>
      <h1 className="font-heading text-5xl font-bold text-foreground mb-2">404</h1>
      <p className="text-muted-foreground mb-8 max-w-sm">
        We couldn't find that page. It may have moved or the link is incorrect.
      </p>
      <div className="flex gap-3">
        <Link to="/" data-testid="notfound-home-link">
          <Button className="rounded-full">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>
        <Link to="/directory" data-testid="notfound-directory-link">
          <Button variant="outline" className="rounded-full">Browse Stores</Button>
        </Link>
      </div>
    </div>
  );
}
